export default "__VITE_ASSET__BJo$eRmK__"